import bongroupLogo from '../../assets/svg/partner-bongroup.svg'
import bongroupLogoBlack from '../../assets/svg/partner-bongroup-b.svg'
import codereLogo from '../../assets/svg/partner-codere.svg'
import codereLogoBlack from '../../assets/svg/partner-codere-b.svg'
import pyradiaLogo from '../../assets/svg/partner-pyradia.svg'
import pyradiaLogoBlack from '../../assets/svg/partner-pyradia-b.svg'
import hemoLogo from '../../assets/svg/partner-hemo.svg'
import hemoLogoBlack from '../../assets/svg/partner-hemo-b.svg'
import lpwLogo from '../../assets/svg/partner-LPW.svg'
import lpwLogoBlack from '../../assets/svg/partner-LPW-b.svg'
import mecanolavLogo from '../../assets/svg/partner-mecanolav.svg'
import mecanolavLogoBlack from '../../assets/svg/partner-mecanolav-b.svg'
import { getLang } from '../util/i18n.js'
import { getPartnersTexts } from '../data/partnersTexts.js'
class SamtPartners extends HTMLElement {
  connectedCallback() {
    this.render()
  }

  bindCardLinkEvents() {
    const cardButtons = this.querySelectorAll('[data-partner-card]')
    cardButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const targetLink = button.dataset.link
        if (targetLink) {
          window.location.href = targetLink
        }
      })
    })
  }

  render() {
    const mobileDetail = (
      this.getAttribute('show-detail') || 'show'
    ).toLowerCase()
    const mobileDetailHidden = ['hide', 'hidden', 'false', '0'].includes(
      mobileDetail
    )
    const detailDisplayClass = mobileDetailHidden ? 'hidden' : 'flex'
    const mobileScrollCenterAttr = this.getAttribute('mobile-scroll-center')
    const mobileScrollCenterEnabled =
      mobileScrollCenterAttr === null
        ? true
        : !['false', '0', 'off', 'no'].includes(
            mobileScrollCenterAttr.toLowerCase()
          )

    const lang = getLang()
    const t = getPartnersTexts(lang)
    const logos = {
      bongroup: {
        color: bongroupLogo,
        black: bongroupLogoBlack
      },
      codere: {
        color: codereLogo,
        black: codereLogoBlack
      },
      pyradia: {
        color: pyradiaLogo,
        black: pyradiaLogoBlack
      },
      hemo: {
        color: hemoLogo,
        black: hemoLogoBlack
      },
      lpw: {
        color: lpwLogo,
        black: lpwLogoBlack
      },
      mecanolav: {
        color: mecanolavLogo,
        black: mecanolavLogoBlack
      }
    }
    const cards = [
      {
        key: 'bongroup',
        cat: 'media',
        active: true
      },
      {
        key: 'codere',
        cat: 'furnaces',
        active: false
      },
      {
        key: 'pyradia',
        cat: 'furnaces',
        active: false
      },
      {
        key: 'hemo',
        cat: 'cleaning',
        active: false
      },
      {
        key: 'lpw',
        cat: 'cleaning',
        active: false
      },
      {
        key: 'mecanolav',
        cat: 'cleaning',
        active: false
      }
    ]

    const cardsHtml = cards
      .map((card) => {
        const item = t.items[card.key]
        const catText = t.categories[card.cat]
        const logo = logos[card.key]
        const activeState = card.active ? 'true' : 'false'

        return `
        <div class="flex h-full flex-col gap-4">
          <button
            type="button"
            data-partner-card="${card.key}"
            data-link="${item.link || ''}"
            data-active="${activeState}"
            aria-pressed="${activeState}"
            class="group peer flex h-full cursor-pointer flex-col gap-3 rounded-2xl border border-white/50 bg-white/80 p-5 text-left text-[#58585c] transition-colors duration-300 hover:bg-samt-blue hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#00003d] data-[active=true]:bg-samt-blue data-[active=true]:text-white"
          >
          <div class="flex items-center justify-center text-xs uppercase w-full">
            <span
              class="whitespace-nowrap text-center text-[0.6rem] tracking-[0.25em] text-[#b0b0b5] transition-colors duration-300 group-hover:text-white/70 group-data-[active=true]:text-white/70 sm:text-xs sm:tracking-[0.4em]"
              >${catText}</span
            >
          </div>
          <div class="relative h-10 w-full">
            <img
              src="${logo.color}"
              alt="${item.name}"
              class="absolute inset-y-0 left-1/2 h-10 w-auto -translate-x-1/2 object-contain transition-opacity duration-300 group-hover:opacity-0 group-data-[active=true]:opacity-0"
              loading="lazy"
            />
            <img
              src="${logo.black}"
              alt="${item.name}"
              class="absolute inset-y-0 left-1/2 h-10 w-auto -translate-x-1/2 object-contain opacity-0 transition-opacity duration-300 group-hover:opacity-100 group-data-[active=true]:opacity-100"
              loading="lazy"
            />
          </div>
          <p
            class="text-samt-blue pt-3 text-base font-semibold transition-colors duration-300 group-hover:text-white group-data-[active=true]:text-white"
          >
            ${item.name}
          </p>
          <p
            class="min-h-[2.75rem] text-sm leading-snug text-[#c0c0c5] transition-colors duration-300 group-hover:text-white/70 group-data-[active=true]:text-white/70"
          >
            ${item.desc}
          </p>
          </button>
          <span
            class="h-1 w-3/5 origin-right scale-x-0 self-center bg-samt-blue transition-transform duration-500 peer-hover:origin-left peer-hover:scale-x-100 peer-data-[active=true]:origin-left peer-data-[active=true]:scale-x-100"
            aria-hidden="true"
          ></span>
        </div>
      `
      })
      .join('')

    this.innerHTML = `
      <section
        class="home-partners w-full bg-[#f4f4f4] py-24 text-[#1d1d1f] lg:py-28"
      >
        <div
          class="mx-auto flex w-full max-w-[1380px] flex-col gap-4 px-6 md:px-12 xl:px-20"
          data-partners
          data-mobile-scroll-center="${mobileScrollCenterEnabled ? 'true' : 'false'}"
        >
          <div
            class="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between"
          >
            <div class="space-y-6">
              <p
                data-scroll-reveal
                class="text-xs tracking-[0.6em] text-[#8d8d91] uppercase lg:text-sm"
              >

              </p>
              <h2
                data-scroll-reveal
                class="text-samt-blue text-4xl leading-tight font-semibold md:text-5xl lg:text-6xl"
              >
                ${t.title}
              </h2>
            </div>

          </div>

          <div class="w-full h-1"> </div>

          <div
            class="grid gap-10 lg:items-start"
          >
            <div class="grid grid-cols-2 gap-4 md:grid-cols-6">
              ${cardsHtml}
            </div>
          </div>

          <div
              class="${detailDisplayClass} w-full relative isolate flex-col gap-5 overflow-hidden rounded-[1.5rem] bg-samt-blue p-6 text-white sm:gap-6 sm:p-8 lg:p-12"
              data-partner-detail
              aria-live="polite"
            >
              <div
                class="pointer-events-none absolute top-0 -right-16 h-72 w-72 rounded-full bg-white/10 blur-3xl"
              ></div>
              <div
                class="pointer-events-none absolute inset-0 "
              ></div>
              <div class="relative lg:absolute lg:top-10 lg:right-16 flex items-center justify-end">
                <img
                  src="${bongroupLogo}"
                  alt="BON Group logo"
                  class="h-12 w-auto sm:h-16"
                  data-logo
                />
              </div>
              <div class="relative space-y-2">
                <p class="text-xs tracking-[0.4em] text-white/60 uppercase sm:text-base sm:tracking-[0.5em]">
                  ${t.detail.toptitle}
                </p>
                <h3 class="text-2xl font-semibold sm:text-3xl" data-title>
                  ${t.detail.title}
                </h3>
                <p class="text-base text-white/70 sm:text-lg" data-subtitle>
                  ${t.detail.subtitle}
                </p>
              </div>
              <p
                class="relative text-sm leading-relaxed text-white/80 sm:text-base"
                data-description
              >
                ${t.detail.description}
              </p>
              <div
                class="relative flex flex-wrap items-start gap-2 sm:gap-3"
                data-chips
              >
                ${t.detail.tags
                  .map(
                    (tag) => `
                <span
                  class="rounded-full bg-white/10 px-3 py-2 text-[0.65rem] font-semibold tracking-[0.2em] uppercase sm:px-4 sm:text-xs sm:tracking-[0.25em]"
                  >${tag}</span
                >`
                  )
                  .join('')}
              </div>
              <dl class="relative flex flex-col flex-wrap gap-4 sm:flex-row sm:items-end sm:justify-between" data-metrics>
                <div class="space-y-1">
                  <dt class="text-[0.65rem] tracking-[0.35em] text-white/60 uppercase sm:text-xs sm:tracking-[0.45em]">
                    ${t.headings.region}
                  </dt>
                  <dd class="text-base font-semibold text-white sm:text-xl">
                    ${t.detail.metrics.region}
                  </dd>
                </div>
                <div class="space-y-1">
                  <dt class="text-[0.65rem] tracking-[0.35em] text-white/60 uppercase sm:text-xs sm:tracking-[0.45em]">
                    ${t.headings.focus}
                  </dt>
                  <dd class="text-base font-semibold text-white sm:text-xl">
                    ${t.detail.metrics.focus}
                  </dd>
                </div>
                <div class="space-y-1">
                  <dt class="text-[0.65rem] tracking-[0.35em] text-white/60 uppercase sm:text-xs sm:tracking-[0.45em]">
                    ${t.headings.since}
                  </dt>
                  <dd class="text-base font-semibold text-white sm:text-xl">
                    ${t.detail.metrics.since}
                  </dd>
                </div>
                <div class="mt-2 sm:mt-0 sm:ml-auto">
                  <a
                    href="/pages/product.html"
                    data-cta
                    class="inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/30 px-5 py-3 text-[0.65rem] font-semibold tracking-[0.3em] text-white uppercase transition-colors duration-300 hover:border-white hover:bg-white hover:text-[#010044] sm:w-auto sm:px-6 sm:text-xs sm:tracking-[0.45em]"
                  >
                    ${t.cta}
                    <span aria-hidden>→</span>
                  </a>
                </div>
              </dl>
            </div>
        </div>
      </section>
    `
    this.bindCardLinkEvents()
  }
}

customElements.define('samt-partners', SamtPartners)
